<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['date-repeat']['width']" [height]="class['date-repeat']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['date-repeat__content']"
              [textWrapperClass]="class['date-repeat__wrapper']">
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name">
                    <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['date-repeat__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['date-repeat__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['date-repeat__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['date-repeat__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                    <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [(ngModel)]="this.class['date-repeat__content']['line-height']"
                      (nzBlur)="updateClass()" [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['date-repeat__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- ĐỊNH DẠNG THỜI GIAN -->
      <li nz-submenu nzTitle="{{'dinh_dang_thoi_gian' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-time-format-config [objectChoosing]="objectChoosing" [device]="device" [config]="config">
        </app-time-format-config>
      </li>

      <!-- BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-symbol-config [device]="device" [class]="class" [config]="config"
          [symbolClass]="class['date-repeat__wrapper']" [fontSizeIconClass]="class['date-repeat__icon-inner']"
          [symbolConfig]="config['flex-direction']" [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>

      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config [config]="config" [class]="class" [staticdata]="staticdata" [device]="device"
          [objectChoosing]="objectChoosing" [textContentClass]="class['date-repeat__content']"
          [textWrapperClass]="class['date-repeat__wrapper']" [filterConfig]="config['filter']" [isShape]="false">
        </app-text-style-config>
      </li>

      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['date-repeat__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>

      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['date-repeat__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->

          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing" [isBlock]="false">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['date-repeat__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>